var map = {
	"./device/phone-marker-special.png": 97675,
	"./device/phone-marker.png": 14581,
	"./event/marker-elections.png": 55393,
	"./event/marker-meeting.png": 17961,
	"./event/marker-military.png": 50868,
	"./event/marker-national-date.png": 48539,
	"./event/marker-religious.png": 59156,
	"./event/marker-trial.png": 18382,
	"./incident/marker-generic.png": 3242,
	"./incident/unused/marker-bomb.png": 14680,
	"./incident/unused/marker-criminal.png": 51333,
	"./incident/unused/marker-natural.png": 44033,
	"./incident/unused/marker-sanitary.png": 77100,
	"./incident/unused/marker-shooting.png": 29356,
	"./incident/unused/marker-social.png": 3495,
	"./poi/marker-airport.png": 69822,
	"./poi/marker-embassy.png": 37237,
	"./poi/marker-hospital.png": 96513,
	"./poi/marker-police.png": 6332,
	"./poi/marker-station.png": 94842,
	"./site/site.png": 62056
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 39267;